import { Record } from "immutable";

const defaults = {
    __city: "",
    __country: "",
    __default_billing: false,
    __default_shipping: false,
    __display_name: "",
    __phone: "",
    __line_1: "",
    __line_2: "",
    __shipping_code: "",
    __state: "",
    __warehouse: undefined,
    __zip: "",
    _id: undefined,
    type: "",
};

export class Address extends Record(defaults) {
    declare type: string;
    declare __city: string;
    declare __country: string;
    declare __default_billing: boolean;
    declare __default_shipping: boolean;
    declare __display_name: string;
    declare _id: string;
    declare __phone: string;
    declare __line_1: string;
    declare __line_2: string;
    declare __shipping_code: string;
    declare __state: string;
    declare __warehouse: string;
    declare __zip: string;

    constructor(args: any = {}) {
        super({
            ...args,
        });
    }
}
